import React from 'react'
import { SettingsConsumer, SettingsProvider } from './@core/context/settingsContext'
import ThemeComponent from './@core/theme/ThemeComponent'
import ReactHotToast from './@core/styles/libs/react-hot-toast'
import { Toaster } from 'react-hot-toast'
import UserLayout from './layouts/UserLayout'

// TODO: el layout del sistema tiene que venir con el layout ya


import LoginPage from "./pages/login";
import BaseLayout from "./layouts/BaseLayout";
import { LoaderProvider } from "./context/LoaderContext";
import { Navigate, Outlet, RouterProvider, createBrowserRouter, useLocation } from 'react-router-dom'
import { ConfirmActionProvider } from './context/ConfirmActionContext'
import { GoogleOAuthProvider } from '@react-oauth/google';
import { userStorage } from './utils/localStorage'
import Error404 from './pages/404'
import { RUTAS } from './Rutas'
import Orders from "./pages/orders/Orders";
import DumpTrucks from "./pages/dump-trucks/DumpTrucks";
import SupplierOrders from './pages/supplier-order/SupplierOrders'

const router = createBrowserRouter([
    { path: RUTAS.LOGIN, element: <RedirectIfAuthenticated /> },
    { path: '/', element: <Navigate to={`/${RUTAS.LOGIN}`} /> },
    {
        path: '', element: <ProtectedRoute />, errorElement: <Error404 />, children: [
            {
                path: '', element: <BaseLayout />, children: [
                    {
                        path: '', element: <UserLayout />, children: [
                            { path: RUTAS.HOME, element: <Orders/> },
                            { path: RUTAS.VOLQUETES, element: <DumpTrucks/> },
                            { path: RUTAS.PEDIDOS, element: <SupplierOrders/>}
                        ]
                    }
                ]
            },
        ],
    },
    { path: '', element: <Error404 /> }
]);

function RedirectIfAuthenticated() {
    if (userStorage.hasToken()) {
        return <Navigate to={`/${RUTAS.HOME}`} />
    }

    return <LoginPage />
}

function App() {
    return (
        <Provider>
            <GoogleOAuthProvider clientId={window.GOOGLE_CLIENT_ID}>
                <RouterProvider router={router} />
            </GoogleOAuthProvider>
        </Provider>
    )
}

function Provider({ children }: { children: React.ReactNode }) {
    return (
        <SettingsProvider>
            <SettingsConsumer>
                {({ settings }) => {
                    return (
                        <ThemeComponent settings={settings}>
                            <LoaderProvider>
                                <ConfirmActionProvider>
                                    {children}
                                </ConfirmActionProvider>
                            </LoaderProvider>

                            <ReactHotToast>
                                <Toaster position={settings.toastPosition} toastOptions={{ className: 'react-hot-toast' }} />
                            </ReactHotToast>
                        </ThemeComponent>
                    )
                }}
            </SettingsConsumer>
        </SettingsProvider>
    )
}

function ProtectedRoute() {
    const location = useLocation();

    if (!userStorage.hasToken()) {

        // console.log('returning')

        return <Navigate to={`${RUTAS.LOGIN}`} state={{ from: location }} />
    }

    return <Outlet />
}

export default App
